import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

const initStrength = () => {

    const $items = gsap.utils.toArray<HTMLElement>('.js_about_strength_item');
    
    if($items.length === 0) return;

    $items.forEach((item, index) => {
        console.log(item);

        const $id = item.dataset.id;

        if($id === 'percentage') {
            const els = gsap.utils.toArray<HTMLElement>('[data-item="person"]', item);    
            gsap.set(els, {
                opacity: 0,
                yPercent: 50,
            });
        }
        else if($id === 'person') {
            const els = gsap.utils.toArray<HTMLElement>('[data-item="progress"]', item);    
            gsap.set(els, {
                scaleX: 0,
                transformOrigin: 'left center',
            });
        }

        ScrollTrigger.create({
            trigger: item,
            start: 'top 90%',            
            once: true,
            onEnter: () => {
                gsap.fromTo(item, { 
                    opacity: 0,
                    yPercent: 20,
                }, {
                    opacity: 1,
                    yPercent: 0,
                    duration: 1,
                    ease: 'power4.out',
                    delay: index * 0.1,
                });

                if($id === 'percentage') {
                    const els = gsap.utils.toArray<HTMLElement>('[data-item="person"]', item);    
                    gsap.to(els, {
                        opacity: 1,
                        yPercent: 0,
                        duration: 1,
                        delay: 0.5,
                        ease: 'power4.out',
                        stagger: 0.05,
                    });
                }
                else if($id === 'person') {
                    const els = gsap.utils.toArray<HTMLElement>('[data-item="progress"]', item);    
                    gsap.to(els, {
                        scaleX: 1,
                        duration: 1,
                        delay: 0.5,
                        ease: 'power4.out',
                    });
                }
            },
        });
    });
}
    


const initAboutPage = () => {
    initStrength();

};

export default initAboutPage;